/* 1962 — JS natif du thème : tiroir panier, modale des tailles, fiche produit. */
(function () {
  'use strict';

  var moneyFmt = function (cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  };

  /* ---------- Piège à focus ---------- */
  function trapFocus(container) {
    function handler(e) {
      if (e.key !== 'Tab') return;
      var focusables = container.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
    container.addEventListener('keydown', handler);
    return function () { container.removeEventListener('keydown', handler); };
  }

  /* ---------- Tiroir panier ---------- */
  var drawer = {
    root: null,
    releaseFocus: null,
    lastActive: null,

    el: function () {
      if (!this.root) this.root = document.getElementById('CartDrawer');
      return this.root;
    },

    open: function () {
      var el = this.el();
      if (!el) return;
      this.lastActive = document.activeElement;
      el.hidden = false;
      document.body.classList.add('no-scroll');
      var panel = el.querySelector('.cart-drawer__panel');
      this.releaseFocus = trapFocus(panel);
      var close = el.querySelector('.cart-drawer__close');
      if (close) close.focus();
    },

    close: function () {
      var el = this.el();
      if (!el || el.hidden) return;
      el.hidden = true;
      document.body.classList.remove('no-scroll');
      if (this.releaseFocus) this.releaseFocus();
      if (this.lastActive) this.lastActive.focus();
    },

    refresh: function (thenOpen) {
      var self = this;
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections['cart-drawer'];
          if (!html) return;
          var tpl = document.createElement('div');
          tpl.innerHTML = html;
          var fresh = tpl.querySelector('#CartDrawer');
          var current = self.el();
          if (fresh && current) {
            var wasOpen = !current.hidden;
            current.innerHTML = fresh.innerHTML;
            current.hidden = fresh.hidden && !wasOpen && !thenOpen;
          }
          self.updateCount();
          if (thenOpen) self.open();
        });
    },

    updateCount: function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          var label = 'Panier, ' + cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '');
          document.querySelectorAll('[data-cart-button]').forEach(function (el) {
            el.setAttribute('aria-label', label);
          });
        });
    }
  };

  /* ---------- Modale guide des tailles ---------- */
  var sizeGuide = {
    root: null,
    releaseFocus: null,
    lastActive: null,

    el: function () {
      if (!this.root) this.root = document.getElementById('SizeGuide');
      return this.root;
    },

    open: function () {
      var el = this.el();
      if (!el) return;
      this.lastActive = document.activeElement;
      el.hidden = false;
      document.body.classList.add('no-scroll');
      this.releaseFocus = trapFocus(el.querySelector('.size-guide__panel'));
      var close = el.querySelector('.size-guide__close');
      if (close) close.focus();
    },

    close: function () {
      var el = this.el();
      if (!el || el.hidden) return;
      el.hidden = true;
      document.body.classList.remove('no-scroll');
      if (this.releaseFocus) this.releaseFocus();
      if (this.lastActive) this.lastActive.focus();
    }
  };

  /* ---------- Délégation de clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action]');
    if (!t) return;
    var action = t.getAttribute('data-action');

    if (action === 'open-drawer') { e.preventDefault(); drawer.open(); }
    if (action === 'close-drawer') { e.preventDefault(); drawer.close(); }
    if (action === 'open-size-guide') { e.preventDefault(); sizeGuide.open(); }
    if (action === 'close-size-guide') { e.preventDefault(); sizeGuide.close(); }

    if (action === 'line-change') {
      e.preventDefault();
      var line = parseInt(t.getAttribute('data-line'), 10);
      var qty = parseInt(t.getAttribute('data-quantity'), 10);
      var scope = t.getAttribute('data-scope') || 'drawer';
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(function () {
        if (scope === 'page') {
          window.location.reload();
        } else {
          drawer.refresh(false);
        }
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    sizeGuide.close();
    drawer.close();
  });

  /* ---------- Fiche produit ---------- */
  function initProductForm(root) {
    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);
    var variants = data.variants;
    var images = data.images;
    var colorOptionIndex = data.color_index; /* 0-based, -1 si absent */
    var sizeOptionIndex = data.size_index;

    var state = {
      color: root.getAttribute('data-selected-color'),
      size: root.getAttribute('data-selected-size'),
      view: 0,
      qty: 1
    };

    var els = {
      photo: root.querySelector('[data-main-photo]'),
      views: root.querySelector('[data-views]'),
      colorName: root.querySelector('[data-color-name]'),
      price: root.querySelector('[data-price]'),
      lowStock: root.querySelector('[data-low-stock]'),
      addBtn: root.querySelector('[data-add-button]'),
      qtyOut: root.querySelector('[data-qty]'),
      variantInput: root.querySelector('[data-variant-id]')
    };

    function variantFor(color, size) {
      return variants.find(function (v) {
        var okColor = colorOptionIndex < 0 || v.options[colorOptionIndex] === color;
        var okSize = sizeOptionIndex < 0 || v.options[sizeOptionIndex] === size;
        return okColor && okSize;
      });
    }

    function stockOf(color, size) {
      var v = variantFor(color, size);
      if (!v) return 0;
      if (!v.managed) return v.available ? 99 : 0;
      return Math.max(0, v.qty);
    }

    function firstSizeInStock(color) {
      var sizes = sizeButtons().map(function (b) { return b.getAttribute('data-value'); });
      for (var i = 0; i < sizes.length; i++) {
        if (stockOf(color, sizes[i]) > 0) return sizes[i];
      }
      return sizes[0];
    }

    function sizeButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-size-option]'));
    }
    function colorButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-color-option]'));
    }

    function viewsFor(color) {
      if (!color) return images.slice(0, 2);
      var prefix = color.toLowerCase();
      var matched = images.filter(function (img) {
        return (img.alt || '').toLowerCase().indexOf(prefix) === 0;
      });
      matched.sort(function (a, b) {
        var ad = (a.alt || '').toLowerCase().indexOf('dos') >= 0 ? 1 : 0;
        var bd = (b.alt || '').toLowerCase().indexOf('dos') >= 0 ? 1 : 0;
        return ad - bd;
      });
      if (matched.length) return matched;
      var v = variantFor(color, state.size);
      if (v && v.image) return [{ src: v.image, alt: color }];
      if (images.length) return [images[0]];
      return [];
    }

    function render() {
      var v = variantFor(state.color, state.size);
      var stock = stockOf(state.color, state.size);
      var views = viewsFor(state.color);
      if (state.view >= views.length) state.view = 0;

      /* Photo principale */
      if (els.photo) {
        if (views.length) {
          els.photo.innerHTML = '';
          var img = document.createElement('img');
          img.src = views[state.view].src;
          img.alt = views[state.view].alt || '';
          els.photo.appendChild(img);
          els.photo.classList.remove('plate');
        } else {
          els.photo.innerHTML = '<div class="plate-empty">' + (root.getAttribute('data-title') || '') + '</div>';
        }
      }

      /* Vignettes */
      if (els.views) {
        els.views.innerHTML = '';
        if (views.length > 1) {
          views.forEach(function (view, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'product-page__view';
            b.setAttribute('aria-current', i === state.view ? 'true' : 'false');
            b.setAttribute('aria-label', 'Vue ' + (i + 1));
            var im = document.createElement('img');
            im.src = view.src;
            im.alt = '';
            b.appendChild(im);
            b.addEventListener('click', function () {
              state.view = i;
              render();
            });
            els.views.appendChild(b);
          });
        }
      }

      /* Coloris */
      colorButtons().forEach(function (b) {
        b.setAttribute('aria-checked', b.getAttribute('data-value') === state.color ? 'true' : 'false');
      });
      if (els.colorName) els.colorName.textContent = state.color || '';

      /* Tailles */
      sizeButtons().forEach(function (b) {
        var val = b.getAttribute('data-value');
        var s = stockOf(state.color, val);
        b.disabled = s === 0;
        b.setAttribute('aria-checked', val === state.size ? 'true' : 'false');
        b.title = s === 0 ? 'Épuisé' : (s <= 3 ? 'Plus que ' + s : '');
      });

      /* Prix, stock, bouton */
      if (els.price && v) els.price.textContent = moneyFmt(v.price);
      if (els.lowStock) {
        els.lowStock.textContent =
          stock === 0 ? 'Taille épuisée, revenez bientôt' : (stock <= 3 ? 'Plus que ' + stock + ' en stock' : '');
        els.lowStock.hidden = !(stock <= 3);
      }
      if (els.addBtn) {
        els.addBtn.disabled = stock === 0;
        els.addBtn.textContent = stock === 0 ? 'Épuisé' : 'Ajouter au panier';
      }
      if (els.qtyOut) els.qtyOut.textContent = state.qty;
      if (els.variantInput && v) els.variantInput.value = v.id;

      /* URL de variante */
      if (v && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    colorButtons().forEach(function (b) {
      b.addEventListener('click', function () {
        state.color = b.getAttribute('data-value');
        state.view = 0;
        var s = stockOf(state.color, state.size);
        if (s === 0) state.size = firstSizeInStock(state.color);
        render();
      });
    });

    sizeButtons().forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        state.size = b.getAttribute('data-value');
        render();
      });
    });

    var incBtn = root.querySelector('[data-qty-inc]');
    var decBtn = root.querySelector('[data-qty-dec]');
    if (incBtn) incBtn.addEventListener('click', function () { state.qty += 1; render(); });
    if (decBtn) decBtn.addEventListener('click', function () { state.qty = Math.max(1, state.qty - 1); render(); });

    var form = root.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = variantFor(state.color, state.size);
        if (!v || stockOf(state.color, state.size) === 0) return;
        els.addBtn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: v.id, quantity: state.qty })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add-to-cart');
            return r.json();
          })
          .then(function () { return drawer.refresh(true); })
          .catch(function () {})
          .then(function () { render(); });
      });
    }

    /* Taille présélectionnée : jamais une taille épuisée */
    if (stockOf(state.color, state.size) === 0) {
      state.size = firstSizeInStock(state.color);
    }
    render();
  }

  /* Fondu de la nav uniquement quand elle déborde réellement */
  function updateNavClip() {
    document.querySelectorAll('.site-header__nav').forEach(function (nav) {
      nav.classList.toggle('is-clipped', nav.scrollWidth > nav.clientWidth + 1);
    });
  }
  window.addEventListener('resize', updateNavClip);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-product-page]').forEach(initProductForm);
    drawer.updateCount();
    updateNavClip();
  });
})();
